"use client";
import Link from "next/link";
import { useLaunchCommunity } from "~/hooks/useLaunchCommunity";
import { CommunityCreateModal } from "~/components/v3/community-components/CommunityCreateModal";
import { Button } from "~/components/v4/themed/Button";

const RiverHelpsText = () => {
    const { isCommunityCreateVisible, setCreateCommunityVisible } =
        useLaunchCommunity();

    return (
        <div className="flex flex-col items-center justify-center gap-8">
            <h2 className="text-center text-2xl font-[400]">
                Explore the River Platform
            </h2>
            <div className="flex flex-col items-center justify-center gap-4 md:flex-row">
                <span className="rounded-lg bg-[#1B1E24] p-6 text-white">
                    Brands scale engagement
                </span>
                <span className="rounded-lg bg-[#1B1E24] p-6 text-white">
                    Hosts grow their influence
                </span>
                <span className="rounded-lg bg-[#1B1E24] p-6 text-white">
                    Attendees find their tribe
                </span>
            </div>

            <div className="flex flex-col items-center justify-center gap-4 md:flex-row">
                {/* <Button
                    variant="secondary"
                    className="h-[50px] "
                    onClick={() => setCreateCommunityVisible(true)}
                >
                    Launch your community
                </Button> */}
                <Link
                    href="http://getriver.io/"
                    target="_blank"
                    className="flex h-[50px] min-w-max items-center text-white underline underline-offset-4 hover:text-v3-primary"
                >
                    Learn more
                </Link>
            </div>

            <CommunityCreateModal
                isVisible={isCommunityCreateVisible}
                setVisible={(visible, routing) => {
                    setCreateCommunityVisible(visible, routing);
                }}
            />
        </div>
    );
};

export default RiverHelpsText;
